

























import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Card from '@/store/entities/card'
class  CardsPageRequest extends PageRequest{
    keyword:string;
}
class  MediaPageRequest extends PageRequest{
    keyword:string;
    type:string;
}


@Component({
    components:{}
})
export default class Cards extends AbpBase{
    //filters
    pagerequest:CardsPageRequest=new CardsPageRequest();
    mediaPageRequest:MediaPageRequest=new MediaPageRequest();
    get list(){
        return this.$store.state.cards.list;
    };
    get loading(){
        return this.$store.state.cards.loading;
    }
    async create(){
        const cardId = '0';
        this.$router.push({ name: 'card', params: { cardId }})
    }
    async edit(row){ 
        const cardId = row.id;
        this.$router.push({ name: 'card', params: { cardId }})
    }
    pageChange(page:number){
        this.$store.commit('cards/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('cards/setPageSize',pagesize);
        this.getpage();
    }
    async search(){
        this.$store.commit('post/setCurrentPage',1);
        this.getpage();
    }
    async getpage(){         
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;            
        await this.$store.dispatch({
            type:'cards/getAll',
            data:this.pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.cards.pageSize;
    }
    get totalCount(){
        return this.$store.state.cards.totalCount;
    }
    get currentPage(){
        return this.$store.state.cards.currentPage;
    }
    columns=[{
        title:this.L('Title'),
        key:'title'
    },
    {
        title:this.L('Order'),
        key:'order',
        wdith:80
    }
    ,{
        title:this.L('Actions'),
        key:'Actions',
        width:80,
        render:(h:any,params:any)=>{
            return h('ButtonGroup',{props:{vertical:''}},[                 
                h('Button',{
                    props:{
                        type:'primary',
                        icon:'md-arrow-up',
                        ghost:'',
                    },
                    ghost:'',
                    on:{
                        click:async ()=>{
                            await this.$store.dispatch({
                                type:'cards/down',
                                data:params.row
                            }).then( async ()  => {
                                await this.getpage();
                            })                                
                        }
                    }
                },),
                                    h('Button',{
                    props:{
                        type:'primary',
                        size:'small',
                        icon:'md-create'
                    },
                    style:{
                        // marginRight:'5px'
                    },
                    on:{
                        click:()=>{                              
                            this.edit(params.row);
                        }
                    }
                }),  
                    h('Button',{
                    props:{
                        type:'error',
                        icon:'md-trash',
                        size:'small',
                        ghost:'',
                    },
                    ghost:'',
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('DeleteMediaConfirm'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'cards/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },),
                    h('Button',{
                    props:{
                        type:'primary',
                        icon:'md-arrow-down',
                        ghost:'',
                    },
                    ghost:'',
                    on:{
                        click:async ()=>{
                            await this.$store.dispatch({
                                type:'cards/up',
                                data:params.row
                            }).then( async ()  => {
                                await this.getpage();
                            })                                    
                        }
                    }
                },)
            ])
        }
    }]
    async created(){
        this.getpage();
    }
}
